import { useParams, useSearchParams } from 'react-router-dom';

import type { BillingShellSource } from './product/billing-shells.js';
import { AdminBillingShell, CustomerBillingShell } from './product/billing-shells.js';
import { CustomerBillingDetails } from './product/customer-billing-details.js';
import { CustomerPortalFrame } from './product/customer-portal-frame.js';

export function NotFoundRoute() {
  return (
    <main className="shell">
      <section className="panel" aria-labelledby="not-found-title">
        <p className="eyebrow">InfraHub</p>
        <h1 id="not-found-title">No encontrado</h1>
      </section>
    </main>
  );
}

export function CustomerRoute(props: { source: BillingShellSource }) {
  const params = useParams<{ customerPortalAccessId: string }>();
  const customerPortalAccessId = params.customerPortalAccessId ?? '';
  return (
    <CustomerPortalFrame customerPortalAccessId={customerPortalAccessId} source={props.source}>
      <CustomerBillingShell customerPortalAccessId={customerPortalAccessId} source={props.source} />
    </CustomerPortalFrame>
  );
}

export function CustomerDetailsRoute(props: { source: BillingShellSource }) {
  const params = useParams<{
    customerPortalAccessId: string;
    receivableId: string;
    paymentId: string;
    invoiceDocumentId: string;
    paymentComplementDocumentId: string;
  }>();
  const [searchParams] = useSearchParams();
  const search = searchParams.get('search') ?? undefined;
  const customerPortalAccessId = params.customerPortalAccessId ?? '';
  return (
    <CustomerPortalFrame customerPortalAccessId={customerPortalAccessId} source={props.source}>
      <CustomerBillingDetails
        customerPortalAccessId={customerPortalAccessId}
        source={props.source}
        {...(params.receivableId === undefined ? {} : { receivableId: params.receivableId })}
        {...(params.paymentId === undefined ? {} : { paymentId: params.paymentId })}
        {...(params.invoiceDocumentId === undefined
          ? {}
          : { invoiceDocumentId: params.invoiceDocumentId })}
        {...(params.paymentComplementDocumentId === undefined
          ? {}
          : { paymentComplementDocumentId: params.paymentComplementDocumentId })}
        {...(search === undefined ? {} : { search })}
      />
    </CustomerPortalFrame>
  );
}

export function AdminRoute(props: { source: BillingShellSource }) {
  const params = useParams<{ tenantId: string; customerId: string }>();
  return (
    <AdminBillingShell
      tenantId={params.tenantId ?? ''}
      customerId={params.customerId ?? ''}
      source={props.source}
    />
  );
}
